import React, { ReactNode } from 'react';
import { AppBar, Tab, Tabs } from '@mui/material';

import { assertExhaustiveSwitch } from '@paragon/utilities';

import { setActiveList } from '../../../store/batchesAndBundlesTabSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { BatchesAccordion } from './BatchesAccordion';
import { BundlesAccordion } from './BundlesAccordion';

export function BatchesAndBundlesSidebar() {
  const dispatch = useAppDispatch();
  const activeList = useAppSelector((state) => state.batchesAndBundlesTab.activeList);

  let content: ReactNode;
  switch (activeList) {
    case 'batches':
      content = <BatchesAccordion />;
      break;
    case 'bundles':
      content = <BundlesAccordion />;
      break;
    default:
      assertExhaustiveSwitch(activeList);
  }

  return (
    <>
      <AppBar enableColorOnDark position="static">
        <Tabs
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          value={activeList}
          onChange={(_, value) => void dispatch(setActiveList(value))}
        >
          <Tab label="Batches" value="batches" />
          <Tab label="Bundles" value="bundles" />
        </Tabs>
      </AppBar>
      {content}
    </>
  );
}
